//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RegisterForm from '../../../../shared-components/generico/RegisterForm';
import UploadFile from '../../../../shared-components/upload/UploadFile';
import InputDatepicker from '../../../../shared-components/datepicker/InputDatepicker';

import { basePath } from '../../common/resources/importacoes';

export default {
  name: 'ImportacaoSideColumn',
  props: {
    tipos: {
      type: Array,
      default() { return []; },
    },
    exibeCancelar: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialog: {
        ref: 'dialog1',
        from: 'saveRegisterFromButton',
        title: this.$t('label.atencao'),
        content: '',
        action() {},
      },
      uploadFileUrl: `${basePath}/importacao`,
      foo: 'hello',
      importacaoId: -1,
      showBlockDropzone: true,
      dataInicio: '',
      dataFim: '',
      urlFim: '',
    };
  },
  computed: {
    hasUploadFileUrl() {
      const notEmpty = this.uploadFileUrl !== 'empty';
      if (notEmpty) {
        const timeout = setTimeout(() => {
          this.showBlockDropzone = false;
          clearTimeout(timeout);
        }, 3E2);
      }
      return notEmpty;
    },
    importacao() {
      return this.importacaoId !== -1 ?
        this.tipos.find(el => el.id === this.importacaoId) :
        { arquivosSuportados: '' };
    },
    showImportSellIn() {
      if ((!this.errors.has('data_inicio') && this.dataInicio !== '' && this.dataInicio.length === 10) &&
        (!this.errors.has('data_fim') && this.dataFim !== '' && this.dataFim.length === 10)) {
        return this.validarDatas();
      }
      return false;
    },
    showImportSellOut() {
      if ((!this.errors.has('data_inicio') && this.dataInicio !== '' && this.dataInicio.length === 10) &&
        (!this.errors.has('data_fim') && this.dataFim !== '' && this.dataFim.length === 10)) {
        return this.validarDatas();
      }
      return false;
    },
    uploadFileDropzoneId() {
      return `myVueDropzone${(Math.random() * Math.random() * 100).toString().replace('.', '')}`;
    },
  },
  components: {
    RegisterForm,
    UploadFile,
    InputDatepicker,
  },
  methods: {
    enviandoArquivo(data, xhr, formData) {
      const parametros = { data_inicio: this.dataInicio, data_fim: this.dataFim };
      formData.append('id_tipo_importacao', this.importacao.id);
      formData.append('parametros', JSON.stringify(parametros));
    },
    cancelarImportacao() {
      this.$emit('IMPORTACAO_LATERACAO_CANCELAR');
    },
    closeDialog(ref, cb) {
      this.$refs[ref].close();
      if (cb) {
        cb();
      }
    },
    dataInicialFormatada(dataInicial) {
      this.dataInicio = dataInicial;
    },
    dataFimFormatada(dataFim) {
      this.dataFim = dataFim;
    },
    validarDatas() {
      const inicio = this.moment(this.dataInicio, 'DD-MM-YYYY');
      const fim = this.moment(this.dataFim, 'DD-MM-YYYY');
      if (inicio > fim) {
        this.$toast.create(this.$t('errors.data.final_antes_inicial'), 'snack', 8E3);
        return false;
      }
      return true;
    },
    openDialog(ref) {
      this.$refs[ref].open();
    },
    openSaveDialog(ref, from) {
      if (this.validateFields()) {
        const content = this.$t('message.salvar_novo_canal');
        this.setDialogContent(content, null, from || this.dialog.from);

        this.openDialog(ref || this.dialog.ref);
      }
    },
    setDialogContent(content, action, from) {
      // TODO: trocar tipo.nome.replace(/\_/g,' ').replace('importacao', '') por descricao,
      // que sera desenvolvido em breve
      // this.dialog.content = content || concat(this.$t('message.deseja_importar_novo'),
      // descricao aqui, '?');
      // TODO deletar linha abaixo
      this.dialog.content = content || this.$t('message.deseja_importar');
      this.dialog.action = action || this.save;
      this.dialog.from = from || this.dialog.from;
    },
    uploadError(file, msg) {
      this.$toast.create(msg || this.$t('message.erro_tente_importar_novamente'), 'snack', 5E3);
    },
    uploadSuccess() {
      this.$toast.create(this.$t('message.importado_em_breve_sera_processado'), 'snack', 8E3);
      this.$emit('IMPORTACAO_LATERACAO_UPLOAD');
    },
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/importacao/ImportacaoLateral.vue?vue&type=script&lang=js&